import { render, staticRenderFns } from "./CardDetailsModal.vue?vue&type=template&id=4d2f0a3a&scoped=true"
import script from "./CardDetailsModal.vue?vue&type=script&lang=js"
export * from "./CardDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./CardDetailsModal.vue?vue&type=style&index=0&id=4d2f0a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f0a3a",
  null
  
)

export default component.exports